<script setup>
const props = defineProps({
  ann:{
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false
  },
  isMenu: {
    type: Boolean,
    default: false
  },
  isEnd: {
    type: Boolean,
    default: false
  }
})

import { VideoStore } from '@/front/stores/video_store.js';
import { PlayerStore } from '@/front/stores/player_store.js';
import { AnnStore } from '@/front/stores/ann_store.js';
import { ClickStore } from '@/front/stores/click_store.js';
const videoStore = VideoStore();
const playerStore = PlayerStore();
const annStore = AnnStore();
const router = useRouter();
const clickStore = ClickStore();
const { t } = useI18n();

import { firstValidValue } from '@/front/composables/GeneralHelper.js';



import { PositionCalculator } from '@/front/composables/PositionCalculator.js';
const { calculatePosition, getWidthRatio } = PositionCalculator()

const customStyle = props.ann.customStyle && JSON.parse(props.ann.customStyle) || {}
const styling = computed(() => {
  const baseDesign = videoStore.video.design || {}
  const widthRatio = getWidthRatio(props.ann)


  const dimensions = calculatePosition(props.ann)
  // const br = 0.3 * props.ann.border_radius + 'rem'
  let br = (widthRatio * firstValidValue(props.ann.border_radius, customStyle.borderRadius, baseDesign.button_border_radius) / 5) + 'rem'
  
  const bw = (playerStore.layerDimensions.width / 600) * 0.1 


  let bgColor = props.ann.background_color || customStyle.background_color || baseDesign.button_background_color
  let textColor = props.ann.text_color || customStyle.color || baseDesign.button_text_color
  let opacity = props.disabled ? 0.5 : 1
  let cursor = props.disabled ? 'not-allowed' : 'pointer'
  
  if (props.ann.post_click_state == "color" && props.ann.clicked) {
    bgColor = props.ann.post_click_color
    textColor = props.ann.post_click_text_color
  }

  // log.info(5,"🔎 LayerButton styling", bgColor)
  return {
    'width': `${dimensions.width}px`,
    'height': `${dimensions.height}px`,
    'left': `${dimensions.left}px`,
    'top': `${dimensions.top}px`,
    'minHeight': `${dimensions.minHeight}px`,
    'fontSize': `${dimensions.fontSize}px`,
    'color': textColor, 
    'background': bgColor, 
    'borderColor': props.ann.border_color || customStyle.borderColor || baseDesign.button_border_color || 'red',
    'borderWidth': bw + 'rem',
    'borderRadius': br,
    'padding': '0rem ' + Math.max(bw, 0.3) + 'rem',
    'opacity': opacity,
    'cursor': cursor,
  }
})

const transformedContent = computed(() => {
  return annStore.isEditing || videoStore.video.manage ? props.ann.content || t('common.button'): props.ann.transformed_content
})

const isNoneClickAction = computed(() => {
  return props.ann.click_action == 'none'
})

const getButtonClassList = computed(() => {
  return {
    'transform active:scale-[90%] transition-transform': !isNoneClickAction.value,
    [`${props.ann.animation}`]: true,
    'hover:scale-105 z-10': !isNoneClickAction.value,
    '!cursor-not-allowed': props.disabled || isNoneClickAction.value,
    'spotlightMode !z-9999': props.ann.do_spotlight,
    'spotlightDim': annStore.spotlightInteraction && annStore.spotlightInteraction.id != props.ann.id
  }
})

const doMouseEnter = () => {
  if (props.ann.do_spotlight) {
    annStore.startSpotlight(props.ann)
  }
}

const doMouseLeave = () => {
  annStore.endSpotlight()
}
</script>

<template>
  <button
    @mouseenter="doMouseEnter"
    @mouseleave="doMouseLeave"
    class="button shadow-md border-2 w-full h-full transition-all duration-300 select-none overflow-hidden"
    :data-id="ann.id"
    :data-is-menu="isMenu"
    :data-is-end="isEnd"
    :style="styling"
    :class="getButtonClassList"
  >
    <span v-safe-html="transformedContent"></span>
  </button>

</template>